import { Input } from "@repo/core/components/core/Input";
import { ReferenceAccordionProps } from "./types";
import { AccordionContainer } from "@repo/core/components/layout/ProposalAccordion/components/AccordionContainer";
import { InfoSection } from "@repo/core/components/layout/ProposalAccordion/components/InfoSection";
import { RelationshipEnum } from "@repo/core/enums/proposals";
import { VStack } from "@gluestack-ui/themed";

export const ReferenceAccordion = ({
  fullName,
  isShowInput,
  relationship = RelationshipEnum.FRIENDS,
  phone,
  ...rest
}: ReferenceAccordionProps) => {
  return (
    <AccordionContainer {...rest}>
      {isShowInput ? (
        <VStack gap="$4">
          <Input
            label="Nome Completo*"
            name="fullName"
            value={fullName}
            isDisabled
          />
          <Input
            label="Relacionamento*"
            name="relationship"
            value={relationship}
            isDisabled
          />
          <Input
            label="DDD e Celular*"
            name="phone"
            keyboardType="number-pad"
            value={phone}
            isDisabled
          />
        </VStack>
      ) : (
        <>
          <InfoSection title="Nome Completo*" value={fullName} />
          <InfoSection title="Relacionamento*" value={relationship} />
          <InfoSection title="DDD e Celular*" value={phone} />
        </>
      )}
    </AccordionContainer>
  );
};
